import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';

const PricelessCtaSection = () => {
  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-700 text-white min-h-[480px] flex flex-col items-center justify-center text-center px-6 py-20"
        >
          {/* Background Decor */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-400/20 rounded-full blur-[120px] -translate-y-1/2" />
            <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-indigo-400/20 rounded-full blur-[120px] translate-y-1/2" />
          </div>

          <div className="relative z-10 max-w-4xl mx-auto space-y-8">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1]">
              The only full team of AI dental staff{' '}
              <span className="text-blue-200">to run your practice on autopilot.</span>
            </h2>
            
            <p className="text-lg md:text-xl text-blue-100/80 max-w-2xl mx-auto">
              Join practices across the country using Asha Dental to automate their front desk and save 2 days per week.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
              <Link to="/book-demo" className="inline-flex items-center justify-center px-10 py-4.5 bg-white text-blue-600 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl hover:scale-[1.02] transition-all duration-200 gap-2 group">
                Get Started
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>

            <div className="pt-8 flex flex-wrap items-center justify-center gap-8 text-blue-100/60 text-sm font-semibold tracking-wide">
              {['ROI GUARANTEE', 'INSTANT SETUP', '24/7 SUPPORT'].map(item => (
                <div key={item} className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-blue-300" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricelessCtaSection;
